var BLOCK_TAGS = {
    p: true, div: true, ul: true, ol: true, li: true, table: true,
    h1: true, h2: true, h3: true, blockquote: true, pre: true
};

function escapeAttr(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

function unwrap(element) {
    var parent = element.parentNode;
    if (!parent) {
        return;
    }
    while (element.firstChild) {
        parent.insertBefore(element.firstChild, element);
    }
    parent.removeChild(element);
}

function containsBlock(element) {
    var nodes = element.querySelectorAll('p, div, ul, ol, li, table, h1, h2, h3, blockquote, pre');
    return nodes.length > 0;
}

function normalizePastedHtml(html) {
    if (!html || typeof DOMParser === 'undefined') {
        return html || '';
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remove = doc.querySelectorAll('style, script, meta, link, title');
    for (var i = 0; i < remove.length; i++) {
        remove[i].parentNode.removeChild(remove[i]);
    }

    var elements = doc.body.querySelectorAll('*');
    for (var j = 0; j < elements.length; j++) {
        var element = elements[j];
        var tag = element.tagName.toLowerCase();
        var attrs = Array.prototype.slice.call(element.attributes);
        for (var k = 0; k < attrs.length; k++) {
            var name = attrs[k].name.toLowerCase();
            var keep = false;
            if (tag === 'a' && name === 'href') keep = true;
            if (tag === 'img' && (name === 'src' || name === 'alt' || name === 'data-attachment-id')) keep = true;
            if ((tag === 'td' || tag === 'th') && (name === 'colspan' || name === 'rowspan')) keep = true;
            if (!keep) {
                element.removeAttribute(attrs[k].name);
            }
        }
    }

    var spans = Array.prototype.slice.call(doc.body.querySelectorAll('span, font'));
    for (var s = 0; s < spans.length; s++) {
        unwrap(spans[s]);
    }

    var inlines = Array.prototype.slice.call(doc.body.querySelectorAll('b, strong, em, i, u, s, a'));
    for (var n = 0; n < inlines.length; n++) {
        if (containsBlock(inlines[n])) {
            unwrap(inlines[n]);
        }
    }

    return doc.body.innerHTML;
}

function extractDataImages(html) {
    var files = [];
    if (!html || html.indexOf('data:image/') === -1 || typeof DOMParser === 'undefined') {
        return { html: html || '', files: files };
    }

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var images = Array.prototype.slice.call(doc.body.querySelectorAll('img'));
    images.forEach(function(img, index) {
        var src = img.getAttribute('src') || '';
        var match = src.match(/^data:(image\/(?:png|jpeg|gif|webp));base64,([a-z0-9+/=\r\n]+)$/i);
        if (!match) {
            if (src.indexOf('data:image/') === 0 && img.parentNode) {
                img.parentNode.removeChild(img);
            }
            return;
        }

        try {
            var binary = atob(match[2].replace(/\s/g, ''));
            var bytes = new Uint8Array(binary.length);
            for (var i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }
            var mime = match[1].toLowerCase();
            var ext = mime === 'image/jpeg' ? 'jpg' : mime.split('/')[1];
            files.push(new File([bytes], 'immagine-incollata-' + (index + 1) + '.' + ext, { type: mime }));
        } catch (e) {
            // L'immagine base64 non è decodificabile: la togliamo dal testo.
        }

        if (img.parentNode) {
            img.parentNode.removeChild(img);
        }
    });

    return { html: doc.body.innerHTML, files: files };
}

module.exports = {
    escapeAttr: escapeAttr,
    normalizePastedHtml: normalizePastedHtml,
    extractDataImages: extractDataImages,
    BLOCK_TAGS: BLOCK_TAGS
};
